import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { createRoot } from "react-dom/client";
import DOMPurify from "dompurify";
import "@elastic/react-search-ui-views/lib/styles/styles.css";
import { SearchClient } from "./components/SearchClient";
import { ServiceEnum } from "./models/dataModel";
import "./index.css";
function resolveSelector(value, fallback) {
    return typeof value === "string" && value.trim().length > 0 ? value : fallback;
}
function safeQuerySelector(selector) {
    try {
        return document.querySelector(selector);
    }
    catch {
        return null;
    }
}
const searchFieldSelector = resolveSelector(window.TrimbleSearchFieldSelector, "#trimble-search-field");
const resultPageSelector = resolveSelector(window.TrimbleSearchResultsSelector, "#trimble-search-results");
const searchFieldElement = safeQuerySelector(searchFieldSelector);
const resultPageElement = safeQuerySelector(resultPageSelector);
function getLanguage(element) {
    const el = element.getAttribute("data-language");
    return el !== null ? DOMPurify.sanitize(el) : "en";
}
function getProduct(element) {
    const el = element.getAttribute("data-product");
    return el !== null ? DOMPurify.sanitize(el) : undefined;
}
function getVersion(element) {
    const el = element.getAttribute("data-version");
    return el !== null ? DOMPurify.sanitize(el) : undefined;
}
function getSearchTerm(element) {
    const el = element.getAttribute("data-searchTerm");
    return el !== null ? DOMPurify.sanitize(el) : "";
}
function getEnvironment(element) {
    const el = element.getAttribute("data-env");
    return el !== null ? DOMPurify.sanitize(el) : "prod";
}
function getService(element) {
    const el = element.getAttribute("data-service");
    return el !== null ? DOMPurify.sanitize(el) : ServiceEnum.TRIMBLE_HELP;
}
function getPlaceholder(element) {
    const el = element.getAttribute("data-placeholder");
    return el !== null ? DOMPurify.sanitize(el) : undefined;
}
function getApplicationId(element) {
    const el = element.getAttribute("data-app-id");
    return el !== null ? DOMPurify.sanitize(el) : undefined;
}
if (searchFieldElement) {
    const searchFieldRoot = createRoot(searchFieldElement);
    searchFieldRoot.render(_jsx(React.StrictMode, { children: _jsx(SearchClient, { root: searchFieldElement, service: getService(searchFieldElement), env: getEnvironment(searchFieldElement), display: "searchField", product: getProduct(searchFieldElement), placeholder: getPlaceholder(searchFieldElement), version: getVersion(searchFieldElement), searchTerm: getSearchTerm(searchFieldElement), language: getLanguage(searchFieldElement), applicationId: getApplicationId(searchFieldElement) }) }));
}
if (resultPageElement) {
    const resultPageRoot = createRoot(resultPageElement);
    resultPageRoot.render(_jsx(React.StrictMode, { children: _jsx(SearchClient, { root: resultPageElement, service: getService(resultPageElement), env: getEnvironment(resultPageElement), display: "results", product: getProduct(resultPageElement), version: getVersion(resultPageElement), searchTerm: getSearchTerm(resultPageElement), language: getLanguage(resultPageElement), applicationId: getApplicationId(resultPageElement) }) }));
}
